__webpack_require__.p = "/fullstack/";